module.exports = __webpack_public_path__ + "img/file-money.461c92ca.svg";